const MAX_LOG = 20;

// TODO: Define this type when we start using this HistoryLog class, It is 'any' as temporary
type Log = any;

class HistoryLog {
  logs: Log[];
  constructor() {
    this.logs = [];
  }

  add(event: Log) {
    if (this.logs.length > MAX_LOG) {
      this.logs.shift();
    }

    this.logs.push(event);
  }

  reset() {
    this.logs = [];
  }

  lastLog() {
    return this.logs[this.logs.length - 1];
  }

  getLastLogId() {
    const { logId } = this.lastLog() || {};
    return logId;
  }

  getLogIds() {
    return this.logs.map(({ logId }) => logId);
  }
}

/**
 * Create hisotry log
 *
 * @returns {HistoryStore}
 */
export const createHistoryLog = () => new HistoryLog();
